import React, {Component} from 'react';
import {Button, Col, DatePicker, Form, message, Row, Select} from 'antd';
import {connect} from 'react-redux';

import {queryAccountList} from '@api/core/user';
import SelectOrg from '../../comm/SelectOrg';


const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_type: [],
      accountList: [],
      orgUuid: '',
    };
  }

  componentDidMount() {
    this.loadAccount();
    this.setState({
      contract_type: this.props.contract_type,
    });
  }

  submit = e => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.props.search(data);
  };

  onChangeOrg = value => {
    this.setState({
      orgUuid: value,
    });
    this.loadAccount(value);
    this.props.form.setFieldsValue({ userUuid: '' });
  };

  /**
   *获取用户列表
   */
  loadAccount = orgUuid => {
    const uuid = orgUuid || '';
    queryAccountList({ orgUuid: uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  reset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.setState({
      orgUuid: undefined,
    });
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { contract_type: contractType, accountList } = this.state;
    return (
      <Form className="search-form" layout="horizontal" onSubmit={this.submit}>
        <Row type="flex">
          <Col span={3}>
            <FormItem>
              {getFieldDecorator('date')(
                <DatePicker placeholder="申请时间" style={{ width: '100%' }} />,
              )}
            </FormItem>
          </Col>
          <Col span={7}>
            <FormItem label="申请人" {...formItemLayout}>
              <SelectOrg onChange={this.onChangeOrg} orgUuid={this.state.orgUuid} />
            </FormItem>
          </Col>
          <Col span={2}>
            <FormItem style={{ width: '100%' }}>
              {getFieldDecorator('userUuid', {
                rules: [{ message: '姓名不能为空！' }],
              })(
                <Select placeholder="姓名">
                  <Option key="-1">全部</Option>
                  {accountList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem label="状态" {...formItemLayout}>
              {getFieldDecorator('status', {
                rules: [{ message: '' }],
              })(
                <Select placeholder="状态">
                  <Option value="-1">全部</Option>
                  <Option value="0">未分配</Option>
                  <Option value="1">已分配</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem label="合同类型" {...formItemLayout}>
              {getFieldDecorator('type', {
                rules: [{ message: '' }],
              })(
                <Select placeholder="合同类型">
                  <Option value="-1">全部</Option>
                  {contractType.map(item => {
                    return <Option key={item.value}>{item.key}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              <Row type="flex" justify="end">
                <Button type="primary" htmlType="submit" style={{ marginRight: '10px' }}>
                  搜索
                </Button>
                <Button onClick={this.reset} style={{ marginRight: '10px' }}>
                  重置
                </Button>
              </Row>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/Treeselect.js